var map = {
	"./large_cold_cider.png": 1321,
	"./large_cold_coffee.png": 2102,
	"./large_cold_tea.png": 5386,
	"./large_hot_cider.png": 8810,
	"./large_hot_coffee.png": 7687,
	"./large_hot_tea.png": 4257,
	"./large_room_cider.png": 8762,
	"./large_room_coffee.png": 9671,
	"./large_room_tea.png": 6801,
	"./medium_cold_cider.png": 3481,
	"./medium_cold_coffee.png": 6806,
	"./medium_cold_tea.png": 3290,
	"./medium_hot_cider.png": 1338,
	"./medium_hot_coffee.png": 8359,
	"./medium_hot_tea.png": 6081,
	"./medium_room_cider.png": 9674,
	"./medium_room_coffee.png": 6007,
	"./medium_room_tea.png": 6657,
	"./small_cold_cider.png": 3313,
	"./small_cold_coffee.png": 2558,
	"./small_cold_tea.png": 8402,
	"./small_hot_cider.png": 5554,
	"./small_hot_coffee.png": 2271,
	"./small_hot_tea.png": 1273,
	"./small_room_cider.png": 978,
	"./small_room_coffee.png": 6847,
	"./small_room_tea.png": 9193
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2972;